import axios from 'axios';
import authHeader from './auth-header';
import { API_ADMIN_URL } from './config';

const API_URL = API_ADMIN_URL + "/";

class UserService {

  getReport(month) {
    const params = month ? `?month=${month}` : '';
    return axios.get(API_URL + "report" + params, { headers: authHeader() });
  }

  getOrdersByDate(date) {
    return axios.get(API_URL + "report/orders-by-date?date=" + date, { headers: authHeader() });
  }

  searchUser(tool, keyword) {
    console.log(tool)
    return axios.get(API_URL + tool + "?search=" + keyword, { headers: authHeader() });
  }

  getAllUser(tool, indexItem, searchKeyword) {
    if (searchKeyword) {
      return axios.get(API_URL + tool + "?search=" + searchKeyword, { headers: authHeader() });
    } else {
      return axios.get(API_URL + tool + "?indexItem=" + indexItem, { headers: authHeader() });
    }

  }

  deleteUserByUserId(tool, id) {
    return axios.delete(API_URL + tool + "/" + id, { headers: authHeader() });
  }

  updateUserByUserId(tool, id, obj) {
    return axios.put(API_URL + tool + "/" + id, obj, { headers: authHeader() })
  }

  createUser(tool, obj) {
    return axios.post(API_URL + tool, obj, { headers: authHeader() })
  }

  createUserMail(tool, obj) {
    return axios.post(API_URL + `now/${tool}`, obj, { headers: authHeader() })
  }

}

export default new UserService();
